// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"11":"f75d05a80e994420","103":"1185d76ce24fbb4a"}[chunkId] + ".js";
};